import React, { Component } from 'react'
import PropTypes from 'prop-types'

import NextButton, { BackButton } from '../../common/NextButton'
import css from './Users.css'
import EditUserForm from './EditUserForm'
import EditUserModal from './EditUserModal'
import EditUserColumns from './EditUserColumns'

class Users extends Component {
  static propTypes = {
    createAdmin: PropTypes.func.isRequired,
    handleApiError: PropTypes.func.isRequired,
    locations: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      practice_id: PropTypes.number.isRequired,
    })).isRequired,
    onBack: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    practiceId: PropTypes.string.isRequired,
    products: PropTypes.arrayOf(PropTypes.oneOf([
      'dso',
      'reminders',
      'openchair',
      'voip',
      'patientportal',
      'reminderstier2',
      'reviews',
      'crm',
    ])).isRequired,
    removeUser: PropTypes.func.isRequired,
    updateAdmin: PropTypes.func.isRequired,
    users: PropTypes.arrayOf(PropTypes.shape({
      email: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      roles: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        resource_id: PropTypes.number,
        resource_type: PropTypes.string,
      })).isRequired,
    })).isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      email: '',
      loading: false,
      password: '',
      passwordToCompare: '',
      userToUpdate: null,
      userLocations: [],
      userType: 'practice_admin',
    }

    this.handleSubmit = this.handleSubmit.bind(this)
  }

  onInputChange = e => this.setState({ [e.target.name]: e.target.value })
  onAddLocation = (e) => {
    const { userLocations } = this.state
    const val = e.target.value
    const newUserLocations = userLocations.includes(val)
      ? userLocations.filter(loc => loc !== val)
      : [...userLocations, val]
    this.setState({ userLocations: [...newUserLocations] })
  }

  async handleSubmit(e) {
    const { email, password, userLocations, userType } = this.state
    const { createAdmin, handleApiError, practiceId } = this.props
    try {
      e.preventDefault()
      this.setState({ loading: true })
      const resource =
        userType === 'practice_admin' ? practiceId : userLocations
      await createAdmin(resource, email, password, userType)
      this.setState({
        email: '',
        loading: false,
        password: '',
        passwordToCompare: '',
        userLocations: [],
        userType: 'practice_admin',
      })
    } catch (err) {
      handleApiError(err)
    }
  }

  toggleEditModal = (user = null) => this.setState({ userToUpdate: user })

  userTypes = userType => [
    {
      value: 'practice_admin',
      label: 'Practice Admin',
      checked: userType === 'practice_admin',
    },
    {
      value: 'location_admin',
      label: 'Location Admin',
      checked: userType === 'location_admin',
    },
  ]

  render() {
    const {
      email,
      loading,
      password,
      passwordToCompare,
      userToUpdate,
      userLocations,
      userType,
    } = this.state
    const {
      locations,
      onBack,
      onNext,
      products,
      removeUser,
      updateAdmin,
      users,
    } = this.props

    const dso = products && products.indexOf('dso') > -1

    // no delete user that has sent blasts

    return (
      <div className={css.container}>
        <EditUserForm
          dso={dso}
          email={email}
          handleSubmit={this.handleSubmit}
          loading={loading}
          locations={locations}
          onInputChange={this.onInputChange}
          onAddLocation={this.onAddLocation}
          password={password}
          passwordToCompare={passwordToCompare}
          userLocations={userLocations}
          userType={userType}
          userTypes={this.userTypes}
        />
        <EditUserColumns
          dso={dso}
          toggleEditModal={this.toggleEditModal}
          users={users}
        />
        <BackButton handleClick={onBack} />
        <NextButton
          isSubmit={false}
          isDisabled={!users.length}
          handleClick={onNext}
        />
        {userToUpdate && (
          <EditUserModal
            close={this.toggleEditModal}
            dso={dso}
            locations={locations}
            removeUser={removeUser}
            updateAdmin={updateAdmin}
            user={userToUpdate}
            userTypes={this.userTypes}
          />
        )}
      </div>
    )
  }
}
export default Users



// WEBPACK FOOTER //
// ./src/AddPractice/Users/index.js